import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import http from '../http-common';
import { useAuth } from '../provider/AuthProvider';
import UserDataService from '../services/UserService';

const Wrapper = styled.div`
    position: relative;
    width: 45vw;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 7px 8px 14px 1px #cdcdcd;
    border-radius: 8px;
    @media (min-width: 768px) {
        padding: 3em;
    }
    @media (max-width: 768px) {
        width: 80vw;
    }
    @media (max-height: 600px) {
        height: 12em;
        overflow: scroll;
    }
`

const Logo = styled.img`
    width: 60%;
    margin-top: 1em;
    @media (max-width: 768px) {
        width: 85%;
    }
`

const LogoContainer = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const LoginButtonContainer = styled.div`
    margin-top: 1.5em;
`

const LoginButton = styled.button`
    width: 100%;
    background: #FC431F;
    color: #FFFFFF;
    box-shadow: 7px 8px 14px 1px #cdcdcd;
    border: 3px solid #FC431F;
    border-radius: 5px;
`

const FormContainer = styled.div`
    margin-top: 1em;
`

const Login = () => {

    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = useCallback(async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            const token = await UserDataService.login(email, password);
            login(token);
            navigate('/dashboard');
        } catch (error: any) {
            setError(error.response?.data?.message || 'An error occurred');
        }
    }, [email, password, navigate, login]);

    return(
        <Wrapper>
            <Card style={{ height: '100%', border: 'none'}}>
                <Card.Body>
                    <LogoContainer>
                        <Logo src='TroisPrimeLogo.png' />
                    </LogoContainer>
                    <FormContainer>
                        <Form onSubmit={handleLogin}>
                            <Form.Group>
                                <Form.Label className='secondaryColor'>Email address</Form.Label>
                                <Form.Control type='email' placeholder='Enter email' value={email} onChange={(e) => setEmail(e.target.value)} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className='secondaryColor'>Password</Form.Label>
                                <Form.Control type='password' placeholder='Password' value={password} onChange={(e) => setPassword(e.target.value)} />
                            </Form.Group>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            <LoginButtonContainer>
                                <LoginButton type="submit">
                                    Login
                                </LoginButton>
                            </LoginButtonContainer>
                        </Form>
                    </FormContainer>
                </Card.Body>
            </Card>
        </Wrapper>
    )
}

export default Login